import React, { useState } from "react";
import axios from "../../../../Axios";
import { Urls } from "../../../../Urls";
import { toast } from "react-toastify";

import { useMixPanelForTracking } from "../../../../utils/TrackMixPanel";

const CancelIndent = ({ indent_id, indent_id_sub, onClose, getData, companySettingData, userDetails }) => {
    const [remark, setRemark] = useState("");
    const [loading, setLoading] = useState(false);
    const { TrackMixPanel } = useMixPanelForTracking(
        userDetails,
        companySettingData,
    );

    const handleCancel = async () => {
        if (!remark) {
            toast.error("Please enter a remark.");
            return;
        }

        setLoading(true);
        try {
            const res = await axios.post(
                `${Urls.indent}?indent_id=${indent_id}&indent_id_sub=${indent_id_sub}&field=cancelled`,
                { remark: remark }
            );
            if (res.data.status) {
                toast.success(res.data.message);
                getData(); // Reload data
                TrackMixPanel({
                    ModuleName: "Indent",
                    ScreenName: "Indent Tracking ",
                    Data: `indent_id: ${indent_id}, indent_id_sub: ${indent_id_sub}`,
                    Definition: "User has cancelled the indent",
                });
                if (onClose) onClose();



            } else {
                toast.error(res.data.error || "Failed to cancel indent.");
            }
        } catch (error) {
            console.error(error);
            toast.error("Something went wrong.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ padding: "0px" }}>
            <div className="form-group" style={{ marginBottom: "10px" }}>
                <label style={{ fontWeight: "600", fontSize: "13px" }}>
                    Remark <span style={{ color: "red" }}>*</span>
                </label>
                <input
                    type="text"
                    className="form-control"
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                    placeholder="Enter remark..."
                    style={{ marginTop: "5px", fontSize: "13px" }}
                />
            </div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: "15px",
                }}
            >
                <button
                    className="btn btn-danger btn-sm"
                    onClick={handleCancel}
                    disabled={loading}
                    style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                    {loading && <i className="fa fa-spinner fa-spin"></i>}
                    {loading ? "Cancelling..." : "Confirm Cancel"}
                </button>
            </div>
        </div>
    );
};

export default CancelIndent;
